var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMegaphoneRegular(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M576 55.1V456C576 469.3 565.3 480 552 480C538.7 480 528 469.3 528 456V450.3L350.3 401.9C341.1 446.4 302.9 480 256 480C202.1 480 160 437 160 384C160 372.6 161.1 361.7 165.6 351.5L48 319.4V328C48 341.3 37.25 352 24 352C10.75 352 0 341.3 0 328V184C0 170.7 10.75 160 24 160C37.25 160 48 170.7 48 184V192.6L528 61.67V56C528 42.75 538.7 32 552 32C565.3 32 576 42.75 576 56V55.1zM528 400.6V111.4L48 242.3V269.7L528 400.6zM256 432C280.8 432 301.1 413.2 303.7 389.2L212.3 364.2C209.5 370.2 208 376.9 208 384C208 410.5 229.5 432 256 432H256z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMegaphoneRegular);
export default __webpack_public_path__ + "static/media/megaphone-regular.080ef25e19b6db39c9d8e5179fc919e0.svg";
export { ForwardRef as ReactComponent };